import {AlertType, IApiError} from '../types';

export const handleErrorMessage = (error: IApiError | string): string => {
    if (typeof error === 'string') {
        return error;
    }

    const {message, 'hydra:description': hydraDescription, 'i18n:messageCode': i18nMessageCode} = error?.response || {};
    const messageLocalizationMap: Record<string, string> = {
        'Invalid credentials.': 'alerts.authError',
        'Nieprawidłowe dane.': 'alerts.authError',
        'Your account is not confirmed.': 'alerts.accountNotConfirmed',
        'Konto nie zostało potwierdzone.': 'alerts.accountNotConfirmed',
        'Konto nie jest aktywne.': 'alerts.accountNotActive',
        'Konto zostało usunięte.': 'alerts.accountDeleted',
        'Konto jest zaproszeniem.': 'alerts.accountIsInvitation',
    };

    if (message && messageLocalizationMap[message]) {
        return messageLocalizationMap[message];
    }

    if (i18nMessageCode) {
        return i18nMessageCode;
    }

    if (hydraDescription) {
        if (hydraDescription.includes('Token not found')) {
            return 'auth.alert.invalidConfirmRegistrationURL';
        }
        if (hydraDescription.includes('Access Denied')) {
            return 'alerts.accessDenied';
        }
    }

    return message || hydraDescription || 'alerts.baseError';
};
export const handleApiError = (error: IApiError | string): IApiError => ({message: handleErrorMessage(error), type: AlertType.WARNING});
